/** How long the hidden frame is kept: long enough for a slow server to start the download. */
const FRAME_LIFETIME_MS = 60_000;

/**
 * Starts a file download from a link that answers with an attachment, without leaving the page
 * (MYP-124).
 *
 * A hidden frame rather than a new tab or `location.assign`: the vendor's invoice link downloads
 * rather than displays (checked live, 2026-10-06), so a new tab would be left empty and a pop-up
 * blocker can stop one opened after an awaited request; navigating this page would be safe only
 * as long as every answer stays an attachment. A frame does neither — the browser downloads, the
 * page stays as it was. The frame is removed once the download has had time to start.
 */
export function startDownload(url: string): void {
  const frame = document.createElement('iframe');
  frame.hidden = true;
  frame.setAttribute('aria-hidden', 'true');
  frame.tabIndex = -1;
  frame.dataset['download'] = 'invoice';
  frame.src = url;
  document.body.append(frame);
  window.setTimeout(() => frame.remove(), FRAME_LIFETIME_MS);
}
